<template>
  <div class="row1">
    <!-- <div> -->
      <div class="btns">
          <button @click="onTab(0)" :class="{ 'btn-active': index == 0 }">
          产废量同比
          </button>
          <button @click="onTab(1)" :class="{ 'btn-active': index == 1 }">
          产废量环比
          </button>
      </div>
      <AnalysisChart1 v-if="index == 0" />
      <AnalysisChart2 v-else />
    <!-- </div> -->
    <!-- <AssessChart  />  2023年11月10日 注释掉了考核结果-->
  </div>
</template>

<script>
import AnalysisChart1 from './AnalysisChart1'
import AnalysisChart2 from './AnalysisChart2'
import AssessChart from './assessChart'

export default {
  name: 'charts',
  components: {
    AnalysisChart1,
    AnalysisChart2,
    AssessChart
  },
  data () {
    return {
      index: 0
    }
  },
  methods: {
    onTab (i) {
      this.index = i
      console.debug('onTab', this.index)
    }
  }

}
</script>

<style lang="less">
  .row1 {
      display: flex;
      flex-direction: row;
      position: relative;
  }
</style>
